/*
 * types/services/dr2am.tasks.permissions.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbPermissionRole} from './PbPermissionRole';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceListPermissionsResponse model module.
 * @module model/ServiceListPermissionsResponse
 * @version version not set
 */
export class ServiceListPermissionsResponse {
  /**
   * Constructs a new <code>ServiceListPermissionsResponse</code>.
   * @alias module:model/ServiceListPermissionsResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceListPermissionsResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceListPermissionsResponse} obj Optional instance to populate.
   * @return {module:model/ServiceListPermissionsResponse} The populated <code>ServiceListPermissionsResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceListPermissionsResponse();
      if (data.hasOwnProperty('permissions'))
        obj.permissions = ApiClient.convertToType(data['permissions'], [PbPermissionRole]);
      if (data.hasOwnProperty('next_page_token'))
        obj.nextPageToken = ApiClient.convertToType(data['next_page_token'], 'String');
      if (data.hasOwnProperty('total'))
        obj.total = ApiClient.convertToType(data['total'], 'String');
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {Array.<module:model/PbPermissionRole>} permissions
 */
ServiceListPermissionsResponse.prototype.permissions = undefined;

/**
 * @member {String} nextPageToken
 */
ServiceListPermissionsResponse.prototype.nextPageToken = undefined;

/**
 * @member {String} total
 */
ServiceListPermissionsResponse.prototype.total = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceListPermissionsResponse.prototype.state = undefined;


